import { useMutation, UseMutationResult } from '@tanstack/react-query';
import CategoryApiV2 from '../../../lib/api/category/CategoryApiV2';
import { BulkUploadAcceptedResponse } from '../../../types/category/bulkUpload';

export type BulkUploadVariables = {
  file: File;
  /** 전송률(0~100) — 30MB 를 보내는 동안 화면에 표시하기 위함 */
  onUploadProgress?: (percent: number) => void;
};

type UseProductCategoryLinkBulkUploadMutationOptions = {
  onSuccess?: (data: BulkUploadAcceptedResponse, variables: BulkUploadVariables) => void;
  onError?: (error: unknown, variables: BulkUploadVariables) => void;
};

/**
 * CSV 벌크 업로드 요청. 202 로 jobId 만 받고 실제 처리는 워커가 한다.
 *
 * 콜백을 인자로 받아 **useMutation 옵션 레벨**에 넘긴다. mutate(variables, { onSuccess })
 * 형태로 넘기면 컴포넌트가 언마운트되는 순간 콜백이 실행되지 않아
 * (query-core mutationObserver 가 hasListeners() 로 게이트한다), 30MB 전송 중
 * 페이지를 떠나면 202 를 받아도 jobId 를 저장하지 못해 잡이 고아가 된다.
 * 옵션 레벨 콜백은 mutation.execute 가 직접 호출하므로 언마운트와 무관하다.
 */
export const useProductCategoryLinkBulkUploadMutation = (
  options?: UseProductCategoryLinkBulkUploadMutationOptions,
): UseMutationResult<BulkUploadAcceptedResponse, unknown, BulkUploadVariables> =>
  useMutation({
    mutationFn: ({ file, onUploadProgress }: BulkUploadVariables) =>
      CategoryApiV2.uploadProductCategoryLinkBulk(file, onUploadProgress),
    onSuccess: options?.onSuccess,
    onError: options?.onError,
  });
